<div [hidden]="widgets.length === 0 && !ttEdit" class="tt-webpagemenu-dashboard" [ngClass]="{ 'tt-webpagemenu-dashboard--editable': ttEdit }">
    <h3 *ngIf="(!!ttTitle && translateFinished) || ttShowHeadingButtons" class="tt-card__heading" style="display: flex; gap: 0.6rem; margin: 0; padding: 1.4rem 2rem 0">
        <ng-container *ngIf="!!ttTitle && translateFinished">
            {{ ttTitle }}
        </ng-container>
        <span class="fa-fw" (click)="ttEdit = !ttEdit; onEditChange(ttEdit); ttEditChange.emit(ttEdit)" style="margin-left: 0.2rem; position: relative; cursor: pointer">
            <span class="fa-fw fal fa-pencil" [matTooltip]="translations['edit_dashboard_layout']" matTooltipShowDelay="500" [matTooltipDisabled]="ttEdit"></span>
            <!-- style="position: absolute; top: 0; left: 0" -->
            <span *ngIf="ttEdit" class="fa-fw fal fa-slash" [matTooltip]="translations['stop_editing']" matTooltipShowDelay="500" style="position: absolute; top: 0; left: 0"></span>
        </span>
        <span class="fa-fw" (click)="refreshAllWidgets()" style="margin-left: 0.2rem; position: relative; cursor: pointer">
            <span class="fa-fw fal fa-sync-alt" [ngClass]="{ 'fa-spin': !(allWidgetsLoaded$ | async) }" [matTooltip]="translations['reload_data']" matTooltipShowDelay="500"></span>
            <!-- style="position: absolute; top: 0; left: 0" -->
        </span>
    </h3>
    <gridstack
        *ngIf="!!gridOptions"
        [options]="gridOptions"
        (resizeStartCB)="editing = true"
        (resizeStopCB)="stopEditing()"
        (dragStartCB)="editing = true"
        (dragStopCB)="stopEditing()"
        (changeCB)="persistChange($event)"
    ></gridstack>
</div>
